import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { PageHeader, LoadingSpinner } from '../../../components/UI';
import toast from 'react-hot-toast';

export default function DocumentDemandMaster() {
  const [nocTypes, setNocTypes] = useState([]);
  const [selected, setSelected] = useState('');
  const [demands, setDemands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newDoc, setNewDoc] = useState({ document_name:'', document_description:'', is_mandatory:1, sort_order:0 });
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get('/masters/noc-types').then(r => setNocTypes(r.noc_types||[])); }, []);

  const loadDemands = async (nocId) => {
    setSelected(nocId); setLoading(true);
    const r = await api.get(`/masters/document-demands/${nocId}`);
    setDemands(r.demands||[]); setLoading(false);
  };

  const addDemand = async () => {
    if (!newDoc.document_name || !selected) return;
    setSaving(true);
    try {
      await api.post('/masters/document-demands', { ...newDoc, noc_type_id: selected });
      toast.success('Added'); loadDemands(selected);
      setNewDoc({ document_name:'', document_description:'', is_mandatory:1, sort_order:0 });
    } catch { toast.error('Failed'); } finally { setSaving(false); }
  };

  const deleteDemand = async (id) => {
    await api.delete(`/masters/document-demands/${id}`);
    setDemands(d=>d.filter(x=>x.id!==id)); toast.success('Removed');
  };

  return (
    <div>
      <PageHeader title="Document Demand Master" subtitle="Configure required documents per NOC type" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="card">
          <h3 className="font-semibold text-gray-800 mb-3">Select NOC Type</h3>
          <div className="space-y-2">
            {nocTypes.map(n => (
              <button key={n.id} onClick={() => loadDemands(n.id)}
                className={`w-full text-left px-4 py-3 rounded-xl border text-sm font-medium transition-all ${selected==n.id?'border-blue-500 bg-blue-50 text-blue-700':'border-gray-200 hover:border-blue-300'}`}>
                {n.noc_name}
              </button>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2 space-y-4">
          {!selected ? (
            <div className="card text-center py-12 text-gray-400">
              <p className="text-4xl mb-2">👈</p><p>Select a NOC type to manage its document demands</p>
            </div>
          ) : (
            <>
              <div className="card">
                <h3 className="font-semibold text-gray-800 mb-4">Required Documents</h3>
                {loading ? <LoadingSpinner /> : (
                  demands.length === 0 ? <p className="text-sm text-gray-400 text-center py-4">No documents configured</p> : (
                    <div className="space-y-2">
                      {demands.map((d,i) => (
                        <div key={d.id} className="flex items-center gap-3 p-3 border border-gray-100 rounded-xl">
                          <span className="text-gray-400 text-sm font-mono w-5">{i+1}</span>
                          <div className="flex-1">
                            <p className="text-sm font-medium text-gray-800">{d.document_name}</p>
                            {d.document_description && <p className="text-xs text-gray-400">{d.document_description}</p>}
                          </div>
                          <span className={`text-xs px-2 py-0.5 rounded-full ${d.is_mandatory?'bg-red-100 text-red-600':'bg-gray-100 text-gray-500'}`}>
                            {d.is_mandatory?'Required':'Optional'}
                          </span>
                          <button onClick={() => deleteDemand(d.id)} className="text-red-400 hover:text-red-600 text-sm">🗑️</button>
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>

              <div className="card border-2 border-dashed border-gray-200">
                <h3 className="font-semibold text-gray-700 mb-3">+ Add Document Demand</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="sm:col-span-2">
                    <label className="form-label">Document Name *</label>
                    <input className="form-input" value={newDoc.document_name} onChange={e=>setNewDoc(p=>({...p,document_name:e.target.value}))} placeholder="e.g. ID Proof (Aadhar/PAN)" />
                  </div>
                  <div className="sm:col-span-2">
                    <label className="form-label">Description</label>
                    <input className="form-input" value={newDoc.document_description} onChange={e=>setNewDoc(p=>({...p,document_description:e.target.value}))} placeholder="Optional description" />
                  </div>
                  <div>
                    <label className="form-label">Type</label>
                    <select className="form-select" value={newDoc.is_mandatory} onChange={e=>setNewDoc(p=>({...p,is_mandatory:e.target.value}))}>
                      <option value={1}>Mandatory</option><option value={0}>Optional</option>
                    </select>
                  </div>
                  <div>
                    <label className="form-label">Sort Order</label>
                    <input type="number" className="form-input" value={newDoc.sort_order} onChange={e=>setNewDoc(p=>({...p,sort_order:e.target.value}))} />
                  </div>
                </div>
                <button onClick={addDemand} className="btn-primary mt-4 text-sm" disabled={saving||!newDoc.document_name}>
                  {saving?'Adding...':'+ Add Document'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
